import api from './api';

/**
 * Obtener todos los almacenes
 */
export const getWarehouses = async (params = {}) => {
  try {
    console.log('📡 [warehousesService] Enviando petición GET a:', '/api/configuration/warehouses');
    console.log('📋 [warehousesService] Parámetros:', params);
    
    const response = await api.get('/configuration/warehouses', { params });
    
    console.log('✅ [warehousesService] Respuesta recibida exitosamente');
    console.log('📦 [warehousesService] Response completo:', response);
    console.log('📊 [warehousesService] Response.data:', response.data);
    console.log('🔍 [warehousesService] Tipo de response.data:', typeof response.data);
    console.log('📈 [warehousesService] response.data.success:', response.data?.success);
    console.log('📋 [warehousesService] response.data.data:', response.data?.data);
    console.log('🔢 [warehousesService] Cantidad de almacenes:', Array.isArray(response.data?.data) ? response.data.data.length : 'No es un array');
    
    if (Array.isArray(response.data?.data)) {
      console.log('📝 [warehousesService] Primeros 3 almacenes:', response.data.data.slice(0, 3));
      console.log('🔑 [warehousesService] Estructura de un almacén:', response.data.data[0] ? Object.keys(response.data.data[0]) : 'No hay almacenes');
    }
    
    return response.data;
  } catch (error) {
    console.error('❌ [warehousesService] Error al obtener almacenes:', error);
    console.error('📊 [warehousesService] Error.response:', error.response);
    console.error('📋 [warehousesService] Error.response?.data:', error.response?.data);
    console.error('🔢 [warehousesService] Error.status:', error.response?.status);
    throw error;
  }
};

/**
 * Obtener un almacén por ID
 */
export const getWarehouse = async (id) => {
  try {
    const response = await api.get(`/configuration/warehouses/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener almacén:', error);
    throw error;
  }
};

/**
 * Crear un nuevo almacén
 */
export const createWarehouse = async (warehouseData) => {
  try {
    console.log('📡 [warehousesService] Enviando petición POST a:', '/api/configuration/warehouses');
    console.log('📤 [warehousesService] Datos a enviar:', warehouseData);
    
    const response = await api.post('/configuration/warehouses', warehouseData);
    
    console.log('✅ [warehousesService] Almacén creado exitosamente');
    console.log('📦 [warehousesService] Response completo:', response);
    console.log('📊 [warehousesService] Response.data:', response.data);
    console.log('🔍 [warehousesService] Almacén creado:', response.data?.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ [warehousesService] Error al crear almacén:', error);
    console.error('📊 [warehousesService] Error.response:', error.response);
    console.error('📋 [warehousesService] Error.response?.data:', error.response?.data);
    throw error;
  }
};

/**
 * Actualizar un almacén
 */
export const updateWarehouse = async (id, warehouseData) => {
  try {
    console.log('📡 [warehousesService] Enviando petición PUT a:', `/api/configuration/warehouses/${id}`);
    console.log('📤 [warehousesService] ID de almacén:', id);
    console.log('📤 [warehousesService] Datos a enviar:', warehouseData);
    
    const response = await api.put(`/configuration/warehouses/${id}`, warehouseData);
    
    console.log('✅ [warehousesService] Almacén actualizado exitosamente');
    console.log('📦 [warehousesService] Response completo:', response);
    console.log('📊 [warehousesService] Response.data:', response.data);
    console.log('🔍 [warehousesService] Almacén actualizado:', response.data?.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ [warehousesService] Error al actualizar almacén:', error);
    console.error('📊 [warehousesService] Error.response:', error.response);
    console.error('📋 [warehousesService] Error.response?.data:', error.response?.data);
    throw error;
  }
};

/**
 * Eliminar un almacén
 */
export const deleteWarehouse = async (id) => {
  try {
    console.log('📡 [warehousesService] Enviando petición DELETE a:', `/api/configuration/warehouses/${id}`);
    console.log('📤 [warehousesService] ID de almacén a eliminar:', id);
    
    const response = await api.delete(`/configuration/warehouses/${id}`);
    
    console.log('✅ [warehousesService] Almacén eliminado exitosamente');
    console.log('📦 [warehousesService] Response completo:', response);
    console.log('📊 [warehousesService] Response.data:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ [warehousesService] Error al eliminar almacén:', error);
    console.error('📊 [warehousesService] Error.response:', error.response);
    console.error('📋 [warehousesService] Error.response?.data:', error.response?.data);
    throw error;
  }
};

